import React from 'react';
import './Navbar.scss';

const Navbar = () => (
    <nav className="landing-nav">
        <ul className="inline-link-list eds-text-bl eds-l-pad-top-4">
            <li>
                <a href="/about/">About Us</a>
            </li>

            <li>
                <a href="/team/">Team</a>
            </li>

            <li>
                <a href="https://investor.eventbrite.com">Investor Relations</a>
            </li>

            <li>
                <a href="/careers/">Careers</a>
            </li>

            <li>
                <a href="/press/">Press</a>
            </li>

            <li className="is-active">
                <a href="/contact/">Contact Us</a>
            </li>
        </ul>
    </nav>
);
export default Navbar;
